module.exports = __webpack_public_path__ + "static/media/suave.3795e0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/suave.png
// module id = 970
// module chunks = 0